import { useHirerAccount } from './useHirerAccount';
import { useOrderSummary } from './useOrderSummary';

export const usePaymentsData = (orderId: string, country: string) => {
  const orderSummaryResponse = useOrderSummary(orderId, country);

  const hirerAccountResponse = useHirerAccount(orderId);

  return {
    isLoadingPaymentsData:
      orderSummaryResponse.loading || hirerAccountResponse.loading,
    orderSummary: orderSummaryResponse?.orderSummary,
    hirerAccount: hirerAccountResponse?.hirerAccount,
    paymentsDataError:
      orderSummaryResponse?.error || hirerAccountResponse?.error,
  };
};
